module.exports = __webpack_public_path__ + "static/media/digital-sidebar.e899067e.jpg";